export default __webpack_public_path__ + "static/media/atila.9824c557.jpg";